/**
 * Created by Lenovo on 2017/6/21.
 */
import React,{Component} from 'react'
import Link from 'react-router'
export default class ErrorSpan extends Component{
    render(){
        return (
            <div>
                <span className = "">
                      <span id={"error_"+this.props.id}  name="success" ></span>
                      <span className = ""></span>
                </span>
                <p className="form-control-static text-danger">
                    <span style={{fontSize: "20px"}}>*</span>
                </p>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./modules/component/errorSpan.js